import { RateMasterService } from "@/api/services/masterService";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

// types/SVTMRate.ts
export interface VTMRate {
  id: string;
  date: string; // ISO timestamp
  vtmType: string;
  vtm: string;
  isd: string;
  issuer: string;
  rate: string;
  unit: string;
  status: number;
}

interface VTMState {
  loading: boolean;
  VTMListSettlement: VTMRate[];
  VTMbyDateSettlement: VTMRate[];
  VTMListSurrender: VTMRate[];
  VTMbyDateSurrender: VTMRate[];
  error?: string;
}

const initialState: VTMState = {
  loading: false,
  VTMListSettlement: [],
  VTMbyDateSettlement: [],
  VTMListSurrender: [],
  VTMbyDateSurrender: [],
  error: undefined,
};

export const fetchVTM = createAsyncThunk<
  VTMRate[],
  void,
  { rejectValue: string }
>("Rate/fetchVTM", async (_, { rejectWithValue }) => {
  try {
    const response = await RateMasterService.getVTMLatest();
    return response.data ?? response;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to Fetch VTM Data");
  }
});

export const fetchVTMByDate = createAsyncThunk<
  VTMRate[],
  Date,
  { rejectValue: string }
>("Rate/fetchVTMByDate", async (date, { rejectWithValue }) => {
  try {
    const response = await RateMasterService.getVTMByDate(date);
    return response.data ?? response;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to Fetch VTM Data");
  }
});

const RateVTMSlice = createSlice({
  name: "VTMSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVTM.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(
        fetchVTM.fulfilled,
        (state, action: PayloadAction<VTMRate[]>) => {
          const settlementList= action.payload?.filter((type)=> type.vtmType ==="01JTAA0J260CT9K50VKBH6WK52") //Settlement
          state.VTMListSettlement = settlementList;
          const surrenderList= action.payload?.filter((type)=> type.vtmType ==="01JTA9ZQ8CEC2ETG4RDMSYECQM") //Surrender
          state.VTMListSurrender = surrenderList;
          state.loading = false;
        }
      )
      .addCase(fetchVTM.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong in fetching data";
      })
      .addCase(fetchVTMByDate.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(
        fetchVTMByDate.fulfilled,
        (state, action: PayloadAction<VTMRate[]>) => {
          state.loading = false;
          const settlementList= action.payload?.filter((type)=> type.vtmType ==="01JTAA0J260CT9K50VKBH6WK52") //Settlement
          state.VTMbyDateSettlement = settlementList;
          const surrenderList= action.payload?.filter((type)=> type.vtmType ==="01JTA9ZQ8CEC2ETG4RDMSYECQM") //Surrender
          state.VTMbyDateSurrender = surrenderList;
        }
      );
  },
});
export default RateVTMSlice.reducer
